import { useGetMonthName } from 'helpers/hooks'

import styles from './ScheduleBubble.module.scss'

interface ScheduleBubbleProps {
    date: Date
    title: string
    display: 'time' | 'date'
}

const ScheduleBubble = ({
    date,
    title,
    display = 'date'
}: ScheduleBubbleProps) => {
    const dateName = useGetMonthName()

    const formatDate = () => {
        return {
            date: `${dateName.getMonthName(
                date.getMonth(),
                'shorthand'
            )} ${date.getDate()}, ${date.getFullYear()}`,
            time: `${
                date.getHours() > 12
                    ? date.getHours() - 12 < 10
                        ? `0${date.getHours() - 12}`
                        : date.getHours() - 12
                    : date.getHours() < 10
                    ? `0${date.getHours()}`
                    : date.getHours()
            }:${
                date.getMinutes() < 10
                    ? `0${date.getMinutes()}`
                    : date.getMinutes()
            } ${date.getHours() > 12 ? 'PM' : 'AM'}`
        }
    }
    return (
        <div className={styles.bubble}>
            <p className={styles.bubbleTitle}>{title}</p>
            <p className={styles.bubbleSubtitle}>{formatDate()[display]}</p>
        </div>
    )
}

export default ScheduleBubble
